import React from 'react';
import PropTypes from 'prop-types';

import styles from './ListWithActions.module.scss';
import InputNumber from '../../atoms/InputNumber/InputNumber';

function ListWithActions({
  items, setItems, columns, setFieldTouched,
}) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.block}>
        <table className={styles.table}>
          <thead>
            <tr>
              {columns?.map((column, index) => (
                <th key={index}>{column}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {items?.map(({
              id, label, quantity, max,
            }, index) => (
              <tr key={index}>
                <td>{label}</td>
                <td>
                  <InputNumber
                    value={quantity}
                    setFieldValue={(_, value) => {
                      setFieldTouched(true);
                      setItems(id, value);
                    }}
                    isInsideTable
                    max={max}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

ListWithActions.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})),
  setItems: PropTypes.func,
  columns: PropTypes.arrayOf(PropTypes.string),
  setFieldTouched: PropTypes.func,
};

ListWithActions.defaultProps = {
  items: [],
  setItems: () => {},
  columns: [],
  setFieldTouched: () => {},
};

export default ListWithActions;
